import { Routes, RouterModule } from "@angular/router";

import { EditEmailComponent } from "./emailmaintenance/editemail/editemail.component";
import { AddEmailComponent } from "./emailmaintenance/addemail/addemail.component";
import { ScanStationTrackingComponent } from "./scanstationtracking/scanstationtracking.component";
import { DistrictsettingsComponent } from "./districtsettings/districtsettings.component";
import { DistrictCalendarComponent } from "./districtcalendar/district-calendar.component";
import { SecuritySettingsComponent } from "./security-settings/security-settings.component";
import { DistrictSchoolMaintenanceComponent } from "./district-school-maintenance/district-school-maintenance.component";
import { FacilitySetupComponent } from "./facility-setup/facility-setup.component";
import { SystemClockComponent } from "./system-clock/system-clock.component";
import { ApplicationProcessComponent } from "./application-process/application-process.component";
import { DistrictZeroAccountsComponent } from "./district-zero-accounts/district-zero-accounts.component";
import { SchoolTypeSetupComponent } from "./school-type-setup/school-type-setup.component";
import { GradeLevelSetupComponent } from "./grade-level-setup/grade-level-setup.component";
import { DriverVerifyActivationComponent } from "./driver-verify-activation/driver-verify-activation.component";
import { DriverVerifyAuthorizedDriversComponent } from "./driver-verify-authorized-drivers/driver-verify-authorized-drivers.component";
import { DriverVerifyLogComponent } from "./driver-verify-log/driver-verify-log.component";
import { DistrictContactInfoComponent } from "./districtcontactinfo/districtcontactinfo.component";
import { MealSubsidyTypeMaintenanceComponent } from "./meal-subsidy-type-maintenance/meal-subsidy-type-maintenance.component";
import { DigitalIdActivationsComponent } from "./digital-id-activations/digital-id-activations.component";
import { ScanStationTrackingSUComponent } from "./scan-station-tracking-su/scan-station-tracking-su.component";
import { ScanStationRebuildSUComponent } from "./scan-station-rebuild-su/scan-station-rebuild-su.component";
import { AuthguardService } from "../master/services";

export const DistrictAdminRoutes: Routes = [
	{ path: "", redirectTo: "/siteadmin/district", pathMatch: "full" },
	{
		path: "district",
		data: { title: "District Contact Information" },
		component: DistrictContactInfoComponent,
		canActivate: [AuthguardService],
	},
	// { path: 'email', data: { title: 'E-Mail Maintenance' }, component: EmailMaintenanceComponent },
	// { path: 'editemail/:id', data: { title: 'Edit Email',HideSelector:true }, component: EditEmailComponent },
	{
		path: "addemail",
		data: { title: "Add Email", HideSelector: true },
		component: AddEmailComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "facility",
		data: { title: "Facility Maintenance (SU Only)" },
		component: FacilitySetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "schooltype",
		data: { title: "School Type Maintenance" },
		component: SchoolTypeSetupComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "gradelevel",
		data: { title: "Grade Level Maintenance" },
		component: GradeLevelSetupComponent,
		canActivate: [AuthguardService],
	},

	{
		path: "school",
		data: { title: "School Maintenance" },
		component: DistrictSchoolMaintenanceComponent,
		canActivate: [AuthguardService],
	}, //New Version
	{
		path: "scanstationtracking",
		data: { title: "ScanStation Tracking" },
		component: ScanStationTrackingComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "scanstationtrackingsu",
		data: { title: "ScanStation Tracking (SU Only)" },
		component: ScanStationTrackingSUComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "scanstationrebuildsu",
		data: { title: "ScanStation Rebuild (SU Only)" },
		component: ScanStationRebuildSUComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "settings",
		data: { title: "District Settings" },
		component: DistrictsettingsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "calendar",
		data: { title: "District Calendar" },
		component: DistrictCalendarComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "security",
		data: { title: "Security Settings (SU Only)" },
		component: SecuritySettingsComponent,
		canActivate: [AuthguardService],
	},
	// (No longer used) // { path: 'clock', data: { title: 'System Clock Settings (SU Only)' }, component: SystemClockComponent }
	// (No longer used) // { path: 'schedule', data: { title: 'Application Process (SU Only)' }, component: ApplicationProcessComponent },
	{
		path: "zeroaccounts",
		data: { title: "District Zero Out Accounts (SU Only)" },
		component: DistrictZeroAccountsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "mealsubsidy",
		data: { title: "Meal Subsidy Maintenance (SU Only)" },
		component: MealSubsidyTypeMaintenanceComponent,
		canActivate: [AuthguardService],
	},

	{
		path: "driververifyactivation",
		data: { title: "Driver Verify Activation" },
		component: DriverVerifyActivationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "driververifyauthorizeddrivers",
		data: { title: "Driver Verify Authorized Drivers" },
		component: DriverVerifyAuthorizedDriversComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "driververifylog",
		data: { title: "Driver Verify Log" },
		component: DriverVerifyLogComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "digitalidactivation",
		data: { title: "Digital ID Activations (SU Only)" },
		component: DigitalIdActivationsComponent,
		canActivate: [AuthguardService],
	},
];
